import type { Product } from '~/stores/CategoriesStore';

/**
 * Sort products by stock status
 * TODO: remove this function when backend supports sorting by stock
 *
 * @param products - products to sort
 * @returns sorted products
 */
export const sortProductsByStock = (products: Product[]): Product[] => {
  return [...products].sort((a, b) => {
    const aInStock = a.sellable > 0;
    const bInStock = b.sellable > 0;

    return aInStock === bInStock ? 0 : aInStock ? -1 : 1;
  });
};
